// extracted by mini-css-extract-plugin
module.exports = {"md":"maps-menu-item_md_28OQd","ios":"maps-menu-item_ios_4UqTj","icon":"maps-menu-item_icon_1D4mp"};